import { API, graphqlOperation } from 'aws-amplify';
import { apiQuery, apiBatchQuery } from './base';
import { getDashUser, listAppUsers } from '../graphql/queries';

export const getGroupsForUser = async (user, setGroups) => {
  try {
    const dashUserQuery = await API.graphql({
      ...graphqlOperation(getDashUser, {
        id: user.attributes?.sub || user.signInUserSession?.idToken?.payload?.sub,
      }),
      authMode: 'AMAZON_COGNITO_USER_POOLS',
    });
    const dashUser = dashUserQuery.data.getDashUser;
    if (!dashUser || !dashUser.roles.length) {
      return setGroups([]);
    }
    const groupIDs = dashUser.roles.map((item) => {
      return item.groupID;
    });

    const groupFilters = groupIDs.map((id) => ({ id: { eq: id } }));

    const groupQuery = `query GetGroupsByIDs($groupFilters: [ModelGroupFilterInput!]) {
      listGroups(filter: { or: $groupFilters }) {
        items {
          id
          app
          name
          demographics {
            id
            options
            question
            type
          }
          education
          medications
          symptoms
          surveys
        }
      }
    }`;

    return apiQuery(
      groupQuery,
      { groupFilters },
      (data) => setGroups(data.listGroups.items),
      () => setGroups([])
    );
  } catch (error) {
    console.log(error);
    setGroups([]);
  }
};

export const getAppUsersForGroup = (groupID, setUsers) => {
  const query = `
    query GetAppUsersForGroup(
      $limit: Int
      $nextToken: String) {
      listAppUsers(limit: $limit, nextToken: $nextToken) {
        items {
          id
          demographics
          userGroups
          usernames
        }
        nextToken
      }
    }
  `;

  return apiBatchQuery(
    query,
    {},
    'listAppUsers',
    (data) => {
      // Filter client-side to handle both old format (plain strings) 
      // and new DynamoDB format ({ "S": "value" })
      const filteredUsers = data.filter((user) => {
        if (!user.userGroups) return false;
        return user.userGroups.some((g) => {
          // Handle plain string format
          if (typeof g === 'string') return g === groupID;
          // Handle DynamoDB format { "S": "value" }
          if (typeof g === 'object' && g.S) return g.S === groupID;
          return false;
        });
      });
      setUsers(filteredUsers, groupID);
    },
    400
  );
};
